import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectClienteDialogComponent } from './select-cliente-dialog/select-cliente-dialog.component';
import { SelectServicoDialogComponent } from './select-servico-dialog/select-servico-dialog.component';
import { SelectProdutoDialogComponent } from './select-produto-dialog/select-produto-dialog.component';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { UtilPipeModule } from 'src/app/admihair/util-pipe/util-pipe.module';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';



@NgModule({
  declarations: [
    SelectClienteDialogComponent,
    SelectServicoDialogComponent,
    SelectProdutoDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    DialogModule,
    TooltipModule,
    ButtonModule,
    InputTextModule,
    ProgressSpinnerModule,
    FormatPipeModule,
    InputMaskModule,
    MessagesModule
  ],
  exports: [
    SelectClienteDialogComponent,
    SelectServicoDialogComponent,
    SelectProdutoDialogComponent
  ]
})
export class DialogsModule { }
